<template>
  <div class="fair-pay-coming-soon-container">
    <FairPayComingSoonPage />
  </div>
</template>

<script>
import FairPayComingSoonPage from "@components/FairPayComingSoonPage/FairPayComingSoonPage.vue";
export default {
  components: {
    FairPayComingSoonPage,
  },
};
</script>

<style lang="css" scoped>
.fair-pay-coming-soon-container {
  position: relative;
  top: 15px;
  width: 100%;
}
</style>
